<template>
  <div class="content">
    <!-- 筛选查询框 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item>
        <el-button
          :loading="downloadLoading"
          style="margin: 0 0 10px 0px"
          type="primary"
          icon="el-icon-document"
          @click="handleDownload"
        >导出 Excel（数量/ {{ dataList.length }}条）</el-button>
      </el-form-item>
      <el-form-item label="分享者后台账号名: " style="margin-left:20px" v-if="roleId !== 1 && roleId !== 3">
        <el-input v-model="selectForm.sup_username" placeholder="请输入" style="width:250px" clearable></el-input>
      </el-form-item>
      <el-form-item label="订单号: " style="margin-left:20px">
        <el-input
          v-model="selectForm.orderNumber"
          placeholder="请输入订单号"
          style="width:250px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号: " style="margin-left:20px">
        <el-input v-model="selectForm.phone" placeholder="请输入手机号" style="width:250px" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="用户ID: " style="margin-left:20px">
        <el-input
          v-model="userId"
          placeholder="请输入用户id"
          style="width:250px"
          clearable
        ></el-input>
      </el-form-item>-->
      <el-form-item>
        <el-button type="primary" @click="selectBtn">搜索</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div style="height:75%">
      <el-table
        border
        :data="dataList"
        style="width: 100%;overflow-y: scroll;"
        height="calc(100vh - 220px)"
        v-loading="loading"
      >
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column label="订单号" align="center" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.orderNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column label="分享者后台账号名" align="center" width="150">
          <template slot-scope="scope">
            <span>
              {{
              scope.row.sup_username ? scope.row.sup_username : "-"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" width="80" align="center">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p style="text-align:center">
                <span style="color: rgb(59, 59, 59);font-weight:600;">用户id:</span>
                <span style="color:red;font-weight:600">
                  {{
                  scope.row.userId
                  }}
                </span>
              </p>
              <div slot="reference" class="name-wrapper addressDetail">
                <el-tag size="medium">
                  {{
                  scope.row.name ? scope.row.name : "-"
                  }}
                </el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="手机号" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="收货地址" width="280" align="center" prop="address"></el-table-column>
        <el-table-column label="留言" align="center">
          <template slot-scope="scope">
            <span>
              {{
              scope.row.odescribe == "" ? "-" : scope.row.odescribe
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="运费" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.freight ? scope.row.freight : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="使用优惠券" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.coupon ? scope.row.coupon : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单总价" align="center" width="280">
          <template slot-scope="scope">
            <span>
              订单总价:{{ scope.row.cost }}元,{{
              scope.row.vipDisCount
              ? "会员下单享受" + scope.row.vipDisCount + "折,"
              : ""
              }}{{
              scope.row.coupon ? "使用优惠券" + scope.row.coupon + "元," : ""
              }}实际支付{{ scope.row.realityCost }}元
            </span>
          </template>
        </el-table-column>
        <el-table-column label="物流单号" align="center" width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.logisticsNumber == ''" style="color:red">暂未填写</span>
            <span v-if="scope.row.logisticsNumber != ''">
              {{
              scope.row.logisticsNumber
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" align="center" width="180">
          <template slot-scope="scope">
            <span style="color:red">
              {{
              scope.row.status == 0
              ? "未发货"
              : scope.row.status == 1
              ? "已发货"
              : scope.row.status == 2
              ? "已完成"
              : scope.row.status == 3
              ? "退款中"
              : scope.row.status == 4
              ? "已退款"
              : "未付款"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="支付方式" align="center" width="180">
          <template slot-scope="scope">
            <span style="color:red">
              {{
              scope.row.pay_type == 2
              ? "省钱卡余额支付"
              : "微信支付"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="商品明细" width="300" align="center">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.productList" :key="index">
              <div>{{ item.productName }}</div>
              <div>{{ item.price }}元 X {{ item.num }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="下单时间" width="200" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center" v-if="roleId !== 1 && roleId !== 3" fixed="right">
          <template slot-scope="scope">
            <!-- <el-button size="mini" @click="detailsBtn(scope.row)"
              >详情</el-button
            >-->
            <!-- <el-button
              style="margin:10px 0"
              size="mini"
              type="danger"
              @click="fahuoBtn(scope.row)"
              >发货</el-button
            >-->
            <el-button size="mini" type="danger" @click="fahuoBtn(scope.row)">发货</el-button>
            <el-button size="mini" type="danger" @click="deleteBtn(scope.row)" :disabled="isRole">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 发货 -->
    <el-dialog title="发货" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="form">
        <el-form-item label="订单状态: ">
          <el-select v-model="form.status" placeholder="请选择" clearable>
            <div v-for="item in statusList" :key="item.id">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input v-model="form.logisticsNumber" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <el-form :model="form">
        <el-form-item label="发货地址">
          <el-input v-model="form.address" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updataLogisticsNumberBtn">确定</el-button>
      </div>
    </el-dialog>
    <!-- 订单详情 -->
    <el-dialog title="订单详情" :visible.sync="dialogFormVisible2" :close-on-click-modal="false">
      <el-table
        :data="orderDetailArr"
        style="width: 100%;overflow-y: scroll;"
        height="400px"
        v-loading="loading"
      >
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column label="订单号" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.orderNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品id" align="center" prop="id"></el-table-column>
        <el-table-column label="商品名" width="280" align="center" prop="productName"></el-table-column>
        <el-table-column label="数量" align="center" prop="num"></el-table-column>
        <el-table-column label="单价" align="center" prop="price"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectallorder,
  deleteOrder,
  updateSendState,
  updateOrder,
  selectOrderDetail
} from "@/services/mall/order";
import XLSX from "xlsx";
export default {
  data() {
    return {
      adminId: "",
      downloadLoading: false,
      dataList: [],
      orderDetailArr: [],
      loading: true,
      name: "",
      orderNumber: "",
      phone: "",
      userId: "",
      form: {
        logisticsNumber: ""
      },
      pageCount: "",
      pageSize: 8,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      isRole: false,
      statusList: [
        { id: 0, name: "未发货" },
        { id: 1, name: "已发货" },
        { id: 2, name: "已完成" },
        { id: 3, name: "退款中" },
        { id: 4, name: "已退款" }
      ],
      selectForm: {}, //查询条件
      roleId: ""
    };
  },
  created() {
    console.log("this.$store.state.supUser", this.$store.state.supUser);
    if (this.$store.state.supUser.roleId == 1) {
      this.selectForm.adminId = this.$store.state.supUser.id;
      this.roleId = 1;
    }
    if (this.$store.state.supUser.roleId == 3) {
      this.selectForm.adminId = this.$store.state.supUser.id;
      this.roleId = 3;
    }

    this.select();
  },
  methods: {
    select() {
      // 查询订单数据
      selectallorder({ ...this.selectForm }).then(resp => {
        this.dataList = resp.data;
        this.loading = false;
      });
    },

    selectBtn() {
      this.select();
    },

    detailsBtn(row) {
      console.log("------------11111---------", row);
      this.dialogFormVisible2 = true;
      selectOrderDetail(row.orderNumber)
        .then(res => {
          this.orderDetailArr = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 发货弹窗
    fahuoBtn(row) {
      this.dialogFormVisible = true;
      this.form = JSON.parse(JSON.stringify(row));
    },
    // 确认修改
    updataLogisticsNumberBtn() {
      // if (this.form.logisticsNumber == "") {
      //   this.$message.error("请填写物流单号");
      //   return;
      // }
      updateOrder({
        id: this.form.id,
        logisticsNumber: this.form.logisticsNumber || "",
        address: this.form.address,
        status: this.form.status
      }).then(res => {
        this.dialogFormVisible = false;
        this.$message.success("操作成功");
        this.select();
      });
    },
    deleteBtn(row) {
      this.$confirm("此操作将永久删除该订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(row.id);
          deleteOrder(row.id).then(resp => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.select();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 导出数据
    handleDownload() {
      this.downloadLoading = true;
      import("../../vendor/Export2Excel").then(excel => {
        const tHeader = [
          "id",
          "订单号",
          "姓名",
          "手机号",
          "收货地址",
          "留言",
          "订单总价",
          "物流单号",
          "订单状态(0未发货 1已发货 2已完成 3退款中 4已退款)",
          "商品明细",
          "下单时间"
        ];
        const filterVal = [
          "id",
          "orderNumber",
          "name",
          "phone",
          "address",
          "odescribe",
          "cost",
          "logisticsNumber",
          "status",
          "productList",
          "createTime"
        ];
        const dataList = JSON.parse(JSON.stringify(this.dataList));
        const list = dataList.map(item => {
          const product = item.productList.map(item2 => {
            return `${item2.productName}(${item2.price}元)X${item2.num}`;
          });
          item.productList = JSON.parse(JSON.stringify(product));
          return {
            ...item,
            productList: item.productList.join(",")
          };
        });
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "订单列表下载",
          autoWidth: true, //Optional
          bookType: "xlsx" //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    },

    // 导入数据
    importExcel(file) {
      // let file = file.files[0] // 使用传统的input方法需要加上这一步
      const types = file.name.split(".")[1];
      const fileType = ["xlsx", "xlm", "xls"].some(item => item === types);
      if (!fileType) {
        alert("格式错误！请重新选择");
        return;
      }
      this.file2Xce(file).then(tabJson => {
        if (tabJson && tabJson.length > 0) {
          this.xlsxJson = tabJson;
          let dateXlx = tabJson[0].sheet; //导入的数据数组
          console.log("------导入的数据为", this.xlsxJson, dateXlx);
          // 判断每一项的姓名 生日 客户类型是否为空 为空则不导入
          // var result = dateXlx.every((item) => {
          //   console.log(item);
          //   return item.name && item.type;
          // });
          // if (!result) {
          //   this.$message.error("姓名，客户类型不能为空！");
          //   return;
          // }
          // 一项项导入数据
          dateXlx.forEach(item => {
            console.log("item");
            updateSendState(item.id, item["物流单号"]).then(res => {
              this.select();
            });
          });
        }
      });
    },
    file2Xce(file) {
      // return new Promise(function (resolve, reject) {
      return new Promise(function(resolve) {
        const reader = new FileReader();
        reader.onload = function(e) {
          const data = e.target.result;
          this.wb = XLSX.read(data, {
            type: "binary"
          });
          const result = [];
          this.wb.SheetNames.forEach(sheetName => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
            });
          });
          resolve(result);
        };
        reader.readAsBinaryString(file.raw);
        // reader.readAsBinaryString(file) // 传统input方法
      });
    }
  }
};
</script>

<style scoped>
.content {
  margin: 10px auto;
  width: 98%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.addressDetail:hover {
  cursor: pointer;
}
</style>
